import { observer } from 'mobx-react';
import setShowWeatherOption from '../data/mutators/setShowWeatherOption';
import selectWeatherUnitOption from '../data/mutators/selectWeatherUnitOption';
import WeatherOptionState from '../data/store/schema/WeatherOptionState';
import WeatherTemperatureUnit from 'owa-service/lib/contract/WeatherTemperatureUnit';
import WeatherEnabledStatus from 'owa-service/lib/contract/WeatherEnabledStatus';
import getWeatherOptions from '../data/store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import WeatherLocations from './WeatherLocations';
import { isFeatureEnabled } from 'owa-feature-flags';

@observer
export default class WeatherFull extends React.Component<{}, {}> {
    render() {
        let optionStore: WeatherOptionState = getWeatherOptions();
        let calendarConfiguration: MailboxCalendarConfiguration = getCalendarConfiguration();

        let weatherEnabledStatus = getFallbackValueIfNull(
            optionStore.weatherEnabled,
            calendarConfiguration.WeatherEnabled
        );

        let isWeatherEnabled = weatherEnabledStatus !== WeatherEnabledStatus.Disabled;

        let weatherUnit = getFallbackValueIfNull(
            optionStore.weatherUnit,
            calendarConfiguration.WeatherUnit
                ? calendarConfiguration.WeatherUnit
                : WeatherTemperatureUnit.Fahrenheit
        );

        return (
            <div>
                <Toggle
                    onText={strings.options_weather_enabled}
                    offText={strings.options_weather_enabled}
                    checked={isWeatherEnabled}
                    onChange={this.onWeatherShowChange}
                />
                <ChoiceGroup
                    selectedKey={`${weatherUnit}`}
                    label={strings.options_weather_unitLabel}
                    options={[
                        {
                            key: WeatherTemperatureUnit.Fahrenheit.toString(),
                            text: strings.options_weather_fahrenheit,
                        },
                        {
                            key: WeatherTemperatureUnit.Celsius.toString(),
                            text: strings.options_weather_celsius,
                        },
                    ]}
                    onChange={this.onWeatherUnitChange}
                    disabled={!isWeatherEnabled}
                />
                {isFeatureEnabled('cal-weather-addLocations') && (
                    <WeatherLocations disabled={!isWeatherEnabled} />
                )}
            </div>
        );
    }

    private onWeatherShowChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        setShowWeatherOption(checked);
    };

    private onWeatherUnitChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectWeatherUnitOption(parseInt(option.key));
    };
}
